import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import {App} from "./App";
import {Login} from "./auth/Login/Login";
import { CookiesProvider } from "react-cookie";
ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
        {/*<ProSidebarProvider>*/}
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<App />} />
            </Routes>

            {/*<Routes>*/}
            {/*    /!*<Route path="/super-admin/login" element={<SuperAdminLogin />} />*!/*/}
            {/*    /!*<Route path="/super-admin" element={<SuperAdminApp />} />*!/*/}
            {/*    <Route path="/login" element={<Login/>}/>*/}
            {/*    <Route path="/" element={<App/>}/>*/}
            {/*</Routes>*/}
        </BrowserRouter>
        {/*</ProSidebarProvider>*/}
    </CookiesProvider>
  </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();
